/**
 * Compliance reducer slice. Handles:
 *   policy.Decided              — append to policyDecisions log
 *     (the reconciliation side-projection lives in the documents reducer)
 *   compliance.SnapshotProduced — complianceSnapshot
 *
 * Pure function: `(state, ev) => state`.
 */

import type { CdmEvent, EventLogState, ComplianceAuthorityRow } from "@/lib/sse/useSSE";

export function complianceReducer(state: EventLogState, ev: CdmEvent): EventLogState {
  switch (ev.eventType) {
    case "policy.Decided": {
      return { ...state, policyDecisions: [...state.policyDecisions, ev] };
    }
    case "compliance.SnapshotProduced": {
      return {
        ...state,
        complianceSnapshot: {
          snapshotId:           ev.payload.snapshotId as string,
          corridorId:           ev.payload.corridorId as string,
          authorities:          (ev.payload.authorities as ComplianceAuthorityRow[] | undefined) ?? [],
          vatPrefillSavingPct:   ev.payload.vatPrefillSavingPct as number | undefined,
          producedAt:           new Date(ev.occurredAt).getTime(),
        },
      };
    }
    default:
      return state;
  }
}
